import { MESSAGE_SAVE_URL_POST, MESSAGE_SAVE_USERNAME } from "./messages";
import { NoteContainerStyled } from "./style-component";
import { Spin } from 'antd';
import { CloseSquareOutlined, InfoCircleOutlined, LoadingOutlined, WarningOutlined } from '@ant-design/icons';
import { TextNoteProps, UrlProcessType, UsernameProcessType } from "./text-node-with-process-type";

const ICON: Record<TextNoteProps['process'], React.ReactNode> = {
  POST_VISIBLE: <InfoCircleOutlined />,
  SEARCH_POST: <InfoCircleOutlined />,
  USERNAME_NOT_FOUND: <CloseSquareOutlined />,
  VERIFY_HASH: <WarningOutlined />,
  POST_ALREADY_EXIST: <WarningOutlined />,
  SAVE_URL: <InfoCircleOutlined />,
  URL_INVALID: <CloseSquareOutlined />,
  URL_NOT_FOUND: <WarningOutlined />,
  URL_ALREADY_EXIST: <WarningOutlined />,
  CUSTOM_ERROR: <CloseSquareOutlined />,
}

const TextNoteWithProcess: React.FC<TextNoteProps> = ({
  process = "POST_VISIBLE",
  loading = false,
  type = 'username',
  customError = ''
}) => {
  const activeItem = type === 'username'
    ? MESSAGE_SAVE_USERNAME[process as UsernameProcessType]
    : MESSAGE_SAVE_URL_POST[process as UrlProcessType];
  const icon = ICON[process];

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent:'center'}}>
      <NoteContainerStyled $typePost={process} data-testid="text-note-with-process">
        {loading ?
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 18 }} spin />}
            size="small"
          /> :
          <div>{icon}</div>}
        {process === 'CUSTOM_ERROR' ? customError : activeItem?.text}
      </NoteContainerStyled>
    </div>
  )
};

export default TextNoteWithProcess;